import { render, staticRenderFns } from "./clyde_settings.vue?vue&type=template&id=83bf150a&"
import script from "./clyde_settings.vue?vue&type=script&lang=js&"
export * from "./clyde_settings.vue?vue&type=script&lang=js&"
import style0 from "./clyde_settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83bf150a')) {
      api.createRecord('83bf150a', component.options)
    } else {
      api.reload('83bf150a', component.options)
    }
    module.hot.accept("./clyde_settings.vue?vue&type=template&id=83bf150a&", function () {
      api.rerender('83bf150a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/integrations/clyde_settings.vue"
export default component.exports